import { AvailablePlatform } from "../../../../providers/Auth/platform.provider";
import { RolePom } from "../../../domain/user/role-pom";
import { isAdmin, isCfmWasteProducer, IUser } from "../../../domain/user/user";
import { UserTypeLevel } from "../../../domain/user/user-type-level";
import { AddressType, recyclerAddressTypes } from "../../../models/address/address.model";
import { IMutateUserFormInputs } from "./create-user-form.component";

// The api only accepts roles and user types the creating user may assign (UserAccessService in the core api)
export const applyCreateUserPlatformDefaults = (
  inputs: IMutateUserFormInputs,
  platformType: AvailablePlatform,
  isUserAdmin: boolean,
): IMutateUserFormInputs => {
  const result = { ...inputs };

  if (platformType === AvailablePlatform.Cfm && isUserAdmin) {
    // If an admin creates an user with that form on Cfm, the user has automatically the CorporateLevel
    result.userTypeLevel = UserTypeLevel.Corporate;
  }

  if (platformType === AvailablePlatform.Pom && isUserAdmin) {
    // If an admin creates an user with that form on Pom, the user has automatically the role MainContact
    result.rolePom = RolePom.MainContact;
  }

  return result;
};

// Address types users can be assigned to in the create user form, for group addresses and the creator's own addresses
export const assignableAddressTypes: AddressType[] = [
  AddressType.CustomerLocation,
  AddressType.LogisticLocation,
  ...recyclerAddressTypes,
];

// Waste producers may only create waste producers, independent of the group type
export const isRestrictedToWasteProducer = (user: IUser | undefined, platformType: AvailablePlatform): boolean => {
  return platformType === AvailablePlatform.Cfm && isCfmWasteProducer(user) && !isAdmin(user);
};
